
import React from 'react';
import { cn } from '@/lib/utils';

interface CircleSegmentProps {
  day: number;
  currentDay: number;
  phase: string;
  color: string;
  segmentDegrees: number;
  highlightedDay: number | null;
  onHighlight: (day: number | null) => void;
}

export const CircleSegment: React.FC<CircleSegmentProps> = ({
  day,
  currentDay,
  phase,
  color,
  segmentDegrees,
  highlightedDay,
  onHighlight
}) => {
  const rotation = (day - 1) * segmentDegrees;
  const isCurrentDay = day === currentDay;
  const isHighlighted = day === highlightedDay;
  const isMenstruation = phase === 'menstruation';
  
  // Calculate the distance from center - consistent for all days
  const distanceFromCenter = 122; // slightly adjusted for better alignment
  
  return (
    <div
      className={cn(
        "absolute w-8 h-8 -mt-4 -ml-4 rounded-full transition-all duration-300 cursor-pointer flex items-center justify-center",
        isCurrentDay && "scale-110 shadow-md z-20",
        isHighlighted && "ring-2 ring-white z-30"
      )}
      style={{
        backgroundColor: color,
        transform: `rotate(${rotation}deg) translate(${distanceFromCenter}px) rotate(-${rotation}deg)`,
        opacity: isCurrentDay ? 1 : 0.85,
        zIndex: isCurrentDay || isHighlighted ? 30 : 15,
      }}
      onClick={() => onHighlight(day === highlightedDay ? null : day)}
    >
      {isCurrentDay && (
        <div className="absolute inset-0 rounded-full animate-pulse-soft bg-white opacity-30"></div>
      )}
      <div className="text-sm font-bold text-white">
        {day}
      </div>
      {isMenstruation && (
        <div className="absolute -bottom-1 w-1.5 h-1.5 rounded-full bg-white"></div>
      )}
    </div>
  );
};
